import type { Json } from "@/types/supabase.types";
import type { InputFieldEditorRow } from "./input-fields";

type TemplateDefault = Json | undefined;

export function areTemplateDefaultsEqual(
  left: TemplateDefault,
  right: TemplateDefault,
): boolean {
  if (left === right) return true;
  if (left === null || right === null) return false;
  if (typeof left !== "object" || typeof right !== "object") return false;

  if (Array.isArray(left) || Array.isArray(right)) {
    if (!Array.isArray(left) || !Array.isArray(right)) return false;
    return (
      left.length === right.length &&
      left.every((value, index) =>
        areTemplateDefaultsEqual(value, right[index]),
      )
    );
  }

  const leftKeys = Object.keys(left).sort();
  const rightKeys = Object.keys(right).sort();
  return (
    leftKeys.length === rightKeys.length &&
    leftKeys.every(
      (key, index) =>
        key === rightKeys[index] &&
        areTemplateDefaultsEqual(left[key], right[key]),
    )
  );
}

export function withDefinitionDefault(
  field: InputFieldEditorRow,
  defaultValue: InputFieldEditorRow["defaultValue"],
): InputFieldEditorRow {
  const definition = { ...field };
  delete definition.configuredValue;
  delete definition.hasValue;
  return { ...definition, defaultValue };
}
